import React from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { AFFILIATE_API_PATH } from "../actions/constant";
import AffiliateHeader from "./AffiliateHeader";
import Header from "../Header";
import Footer from "../components/Footer";
import CollectionListing from "./CollectionListing";

import {
  fetchCollectionsOfAffiliate,
  updateCurrentCollection
} from "../actions/index";

import "./AffiliateLandingPage.css";

class AffiliateMainBanner extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.collection !== nextProps.match.params.collection
    ) {
      var affiliateId = nextProps.match.params.username;
      var collectionId = nextProps.match.params.collection;

      var affiliateCollectionsUrl =
        AFFILIATE_API_PATH + "getAffiliateCollections.php?id=" + affiliateId;

      this.props.fetchData(affiliateCollectionsUrl, collectionId);
    }
  }
  componentDidMount() {
    var affiliateId = this.props.match.params.username;
    var collectionId = this.props.match.params.collection;

    var affiliateCollectionsUrl =
      AFFILIATE_API_PATH + "getAffiliateCollections.php?id=" + affiliateId;

    this.props.fetchData(affiliateCollectionsUrl, collectionId);
  }
  render() {
    return (
      <div
        className="container-fluid"
        id="main-page-container-affiliateLanding"
      >
        <div className="affiliateBanner">
          <div
            className="header"
            style={{
              height: 50,
              width: "100%",
              position: "absolute",
              backgroundColor: "transparent",
              zIndex: 1
            }}
          >
            <Header
              affiliateLogo={this.props.affiliateLogo}
              affiliateName={this.props.affiliateName}
            />
          </div>
          <div className="affiliateDetails">
            <div className="affiliate-name">
              <AffiliateHeader name={this.props.affiliateName} />
            </div>
          </div>
        </div>
        <div
          className="container-fluid"
          style={{ backgroundColor: "rgb(255,255,255)", paddingBottom: "7rem" }}
        >
          <div className="container collection-list">
            <CollectionListing />
          </div>
          {/*container*/}
        </div>
        {/*container-fluid*/}
        <Footer />
      </div>
    );
  }
}

// export default MainBanner;

const mapStateToProps = (state, ownProps) => {
  return {
    currentCollection: state.collections.current,
    fromAffiliate: state.collections.fromAffiliate,
    contentLoading: state.contentLoading,
    pageLoading: state.pageLoading,
    affiliateName: state.affiliateName,
    affiliateLogo: state.affiliateLogo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: (url, currentid) =>
      dispatch(fetchCollectionsOfAffiliate(url, currentid)),
    updateCurrentCollection: collection =>
      dispatch(updateCurrentCollection(collection))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AffiliateMainBanner)
);



// WEBPACK FOOTER //
// ./src/AffiliateLandingPage/AffiliateMainBanner.jsx